<section class="checklist-node"
         [style.--depth]="depth"
         [cdkDragData]="node"
         cdkDrag
         [cdkDragDisabled]="readOnly"
         cdkDropList
         [id]="nodeDropListId"
         [cdkDropListConnectedTo]="allNodeDropLists"
         [cdkDropListData]="node"
         (cdkDropListDropped)="didDropNode($event)"
>


    <header *ngIf="depth > 0"
            cdkDragHandle
    >
        <i class="fa"
           [class.fa-caret-down]="node.expanded"
           (click)="expand($event, node)"
           [class.fa-caret-right]="!node.expanded"></i>
        <div (click)="expand($event, node)">{{ node.label }}</div>

        <div class="btn-group dropdowns"
             mdbDropdown
            *ngIf="!readOnly">
            <i mdbDropdownToggle class="fas fa-ellipsis-h more clickable" id="checkpoint-dropdown-container"></i>
            <div class="dropdown-menu dropdown-primary dropdown-menu-right">
                <a class="dropdown-item"
                   [translate]="Localization.AddSection"
                   (click)="addNewGroup($event)"></a>
                <a class="dropdown-item"
                   [translate]="Localization.AddCheckpoint"
                   (click)="addNewCheckpoint($event)"></a>
                <hr>
                <a class="dropdown-item"
                   [translate]="Localization.EditSection"
                   (click)="editGroup($event)"></a>
                <a class="dropdown-item"
                   [translate]="Localization.DeleteSection"
                   (click)="deleteGroup($event)"></a>
                <a class="dropdown-item"
                   [translate]="Localization.DuplicateSection"
                   (click)="duplicateGroup($event)"></a>
                <a class="dropdown-item"
                   [translate]="Localization.MakeMultipleCopies"
                   (click)="makeMultipleCopies($event)"></a>
            </div>
        </div>

    </header>

    <main *ngIf="depth == 0 || node.expanded">

        <!-- Recursion of template -->
        <div>
            <app-checklist-node *ngFor="let child of node.childNodes"
                                [node]="child"
                                [buildingId]="buildingId"
                                [readOnly]="readOnly"
                                [allDroplists]="allDroplists"
                                [depth]="depth + 1"
                                (onBecameStale)="onBecameStale.emit()"
                                (onDeleted)="didDelete($event)"
                                (onDuplicated)="didDuplicateNode($event)"></app-checklist-node>
        </div>

        <!-- Rendering of Checkpoints -->
        <div cdkDropList
             [id]="checkpointDropListId"
             [cdkDropListConnectedTo]="allCheckpointDropLists"
             [cdkDropListData]="node"
             (cdkDropListDropped)="didReceive($event)">

            <ng-container *ngFor="let checkpoint of node.checkPoints">
                <app-checklist-checkpoint [checkpoint]="checkpoint"
                                          [cdkDragData]="checkpoint"
                                          [readOnly]="readOnly"
                                          cdkDrag
                                          [cdkDragDisabled]="readOnly"
                                          (onDelete)="removeCheckpoint(checkpoint)"
                                          (onDuplicate)="didDuplicateCheckpoint($event)"></app-checklist-checkpoint>
            </ng-container>

        </div>
    </main>
</section>
